import { render, staticRenderFns } from "./SubjectAreasCreate.vue?vue&type=template&id=24392040&"
import script from "./SubjectAreasCreate.vue?vue&type=script&lang=ts&"
export * from "./SubjectAreasCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports